// extracted by mini-css-extract-plugin
export default {"HtmlEditorPowerUps":"HtmlEditorPowerUps_HtmlEditorPowerUps__lD4DA"};